import { axios } from '@nuskin/axios-util';
const client_ID = '764567a95afb4caba4944cf6f688886c';
const http = axios.create();

async function validateEmail(uuid) {
    let data = {
        value: {
            success: false
        }
    };
    let url = `${process.env.VUE_APP_EMAIL_VERIFICATION_CHECK}/validateEmail?uuid=${uuid}`;
    try {
        let response = await http.get(url, {
            headers: { client_id: client_ID }
        });
        data = response.data.data.dynamoResponse;
    } catch (e) {
        console.error(e, 'Error checking email verification');
    }

    return data;
}

export default {
    validateEmail: validateEmail
};
